// src/app/services/currency-format.service.ts
import { Injectable, LOCALE_ID, inject } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class CurrencyFormatService {
  private currencyPipe: CurrencyPipe;

  constructor() {

    this.currencyPipe = new CurrencyPipe(inject(LOCALE_ID));
  }

  format(value: number, currencyCode: string = 'USD', display: 'code' | 'symbol' | 'name' = 'symbol', digitsInfo: string = '1.2-2'): string | null {
    return this.currencyPipe.transform(value, currencyCode, display, digitsInfo);
  }
}